import './ccf-calendar-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCalendarIconProps extends SvgIconProps {
  bgColor?: string;
  viewBox?: string;
}

/**
 * CcfCalendarIcon used to disply assignment icon in the navigation panel & app space
 * @param props - CcfCalendarIconProps
 * @example -- <CcfCalendarIcon />
 */
export function CcfCalendarIcon(props: CcfCalendarIconProps) {
  return (
    <SvgIcon {...props} viewBox={props.viewBox || '0 0 23 23'}>
      <g id="Calendar" clipPath="url(#clip-Calendar)">
        <g
          id="Group_118164"
          data-name="Group 118164"
          transform="translate(0 24020)"
        >
          <rect
            id="Rectangle_80238"
            data-name="Rectangle 80238"
            width="44"
            height="44"
            rx="2"
            transform="translate(0 -24020)"
            fill="#f2f2f2"
            opacity="0"
          />
          <g
            id="Group_118158"
            data-name="Group 118158"
            transform="translate(0 -24020)"
          >
            <g
              id="Rectangle_80239"
              data-name="Rectangle 80239"
              fill="#fff"
              stroke="#707070"
              strokeWidth="1"
              opacity="0"
            >
              <rect width="20" height="20" stroke="none" />
              <rect x="0.5" y="0.5" width="19" height="19" fill="none" />
            </g>
            <g id="date" transform="translate(0.029 0.003)">
              <path
                id="Path_24899"
                data-name="Path 24899"
                d="M7.107,16H9.33v2.219H7.1V15.99Z"
                transform="translate(-2.672 -5.993)"
                fill="#333333"
              />
              <path
                id="Path_24900"
                data-name="Path 24900"
                d="M7.107,21.326H9.33v2.219H7.1V21.32Z"
                transform="translate(-2.672 -7.991)"
                fill="#333333"
              />
              <path
                id="Path_24901"
                data-name="Path 24901"
                d="M17.772,1.112H14.433V0H12.208V1.112H7.756V0H5.528V1.112H2.2A2.221,2.221,0,0,0-.03,3.326h0V17.774a2.221,2.221,0,0,0,2.219,2.219H17.751a2.225,2.225,0,0,0,2.219-2.226h0V3.319a2.229,2.229,0,0,0-2.226-2.226h0Zm0,16.671H2.208v-10h15.56Zm0-12.226H2.208V3.326H5.542V4.433H7.762V3.32h4.445V4.426h2.219V3.314h3.332Z"
                fill="#333333"
              />
              <path
                id="Path_24902"
                data-name="Path 24902"
                d="M14.218,16h2.219v2.219H14.212V15.99Z"
                transform="translate(-5.338 -5.993)"
                fill="#333333"
              />
              <path
                id="Path_24903"
                data-name="Path 24903"
                d="M14.218,21.326h2.219v2.219H14.212V21.32Z"
                transform="translate(-5.338 -7.991)"
                fill="#333333"
              />
              <path
                id="Path_24904"
                data-name="Path 24904"
                d="M21.326,16h2.219v2.219H21.32V15.99Z"
                transform="translate(-8.002 -5.993)"
                fill="#333333"
              />
              <path
                id="Path_24905"
                data-name="Path 24905"
                d="M21.326,21.326h2.219v2.219H21.32V21.32Z"
                transform="translate(-8.002 -7.991)"
                fill="#333333"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfCalendarIcon;
